import { useMemo } from "react";
import { useContent } from "../hooks";

export const FormattedDate = ({
  date,
  type = "date",
}: {
  date: Date;
  type?: "date" | "datetime";
}) => {
  const {
    meta: { languageKey },
  } = useContent();

  const lang = useMemo(() => {
    switch (languageKey) {
      case "de":
        return "de-DE";
      case "en":
        return "en-GB";
    }
  }, [languageKey]);

  const dateString =
    type === "date"
      ? date.toLocaleDateString(lang, {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      : date.toLocaleString(lang);

  return <span suppressHydrationWarning>{dateString}</span>;
};
